import React, { useState } from "react";
import { CircularProgress, Grid } from "@mui/material";
import { Stack } from "@mui/material";
import { Box } from "@mui/material";
import { Typography } from "@mui/material";
import { useStyles } from "./styles";
import { TextField } from "@mui/material";
import { Button } from "@mui/material";
import * as Yup from "yup";
import { Formik, Form } from "formik";
import { useMutation } from "react-query";
import { useToast } from "../../../hooks/useToast";
import { putPassword } from "../../../services/password";
import { AlertDialog } from "../../../components/AlertDialog";

type MyForm = {
  currentPassword: string;
  password: string;
  confirmPassword: string;
};

const schema = Yup.object().shape({
  currentPassword: Yup.string()
    .min(6, "A senha tem que ter mais que 6 caractéres.")
    .required('* Esse campo é obrigatorio!'),
  password: Yup.string()
    .min(6, "A senha tem que ter mais que 6 caractéres.")
    .required('* Esse campo é obrigatorio!'),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref("password"), null], "As senhas estão diferentes.")
    .required('* Esse campo é obrigatorio!'),
});

export function Security() {
    const styles = useStyles();
    const toast = useToast();
    const [confirmed, setConfirmed] = useState(false)
    const [initialValues] = useState<MyForm>(
    {
        currentPassword : '', 
        password: '',
        confirmPassword: ''
    });

    const updatePassword = useMutation(
        async (data : MyForm) => {
          const response = await putPassword(data);
          return response;
        },
        {
          onSuccess: (res) => {
            console.log('res: ', res)
            toast.show(res.data.message, { severity: "success" });
            onClose()
          },
          onError: (res : any) => {
            toast.show(res.response.data.error, { severity: "error" });
            onClose()
          },
        }
    );
    
    const onSubmit = async (values : any)  => {
        try {
            await updatePassword.mutateAsync(values);
        }catch (err) {
            console.log({ err });
        }
    }
  

  function onClose() {
    setConfirmed((prev) => !prev);
  }

  return (
    <Grid container spacing={2}>
        <Grid item xs={9} lg={5} md={8} sm={12}>
            <Stack>
                <Formik
                    initialValues={initialValues} 
                    onSubmit={onSubmit}
                    validationSchema={schema}
                    validateOnBlur={false}
                    validateOnChange={false}
                    validateOnMount={false}
                    render={(
                      {
                        values, 
                        handleChange, 
                        errors, 
                        handleSubmit, 
                        isSubmitting,
                        validateForm
                      })=>(
                        <Form noValidate>
                            <Box sx={{marginBottom: '2.06rem'}}>
                                <Typography variant="h4" noWrap className={styles.titulo}>
                                    Alterar senha
                                </Typography>
                                <Typography noWrap className={styles.subTitulo}>
                                    Altere sua senha de acesso.
                                </Typography>
                            </Box>
                            <Grid container spacing={2} sx={{marginBottom: '15px'}}>
                                <Grid item xs={12}>
                                    <TextField sx={{width:'100%'}}
                                        name="currentPassword"
                                        fullWidth
                                        variant="outlined"
                                        label="Senha atual"
                                        type="password"
                                        onChange={handleChange}
                                        error={!!errors.currentPassword}
                                        helperText={errors.currentPassword ? errors.currentPassword : null}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField sx={{width:'100%'}}
                                        name="password"
                                        fullWidth
                                        variant="outlined"
                                        label="Nova senha"
                                        type="password"
                                        onChange={handleChange}
                                        error={!!errors.password}
                                        helperText={errors.password ? errors.password : null}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField sx={{width:'100%'}}
                                        name="confirmPassword"
                                        fullWidth
                                        variant="outlined"
                                        label="Repita sua nova senha"
                                        type="password"
                                        onChange={handleChange}
                                        error={!!errors.confirmPassword}
                                        helperText={errors.confirmPassword ? errors.confirmPassword : null}
                                    />
                                </Grid>
                            </Grid>
                            <Box sx={{display: 'flex', justifyContent: 'flex-end'}}>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={()=>{
                                        validateForm().then((res: any)=>{ 
                                              if(Object.keys(res).length !== 0){
                                               return ;
                                              }
                                              console.log('result',res)
                                              onClose()
                                        })
                                    }}
                                >
                                    Salvar
                                </Button>
                            </Box>

                <AlertDialog
                  loading={updatePassword.isLoading}
                  open={confirmed}
                  title={"Deseja salvar a nova senha?"}
                  textAgree={
                    updatePassword.isLoading ? (
                      <CircularProgress size={24} sx={{ color: "#FFF" }} />
                    ) : (
                      "Salvar e alterar senha"
                    )
                  }
                  textClose={"Cancelar"}
                  handleClose={() => {
                    onClose();
                  }}
                  handleAgree={() => {
                    handleSubmit();
                  }}
                />
              </Form>
            )}
          />
        </Stack>
      </Grid>
    </Grid>
  );
}
